export const TOGGLE_PERCENT_LINES = "TOGGLE_PERCENT_LINES";
export const toggle_percent_lines = () => ({ type: TOGGLE_PERCENT_LINES });
